module.exports = __webpack_public_path__ + "static/media/next-icon-hot-hand-towel-o.68a43a25.svg";